export default __webpack_public_path__ + "static/media/playStore.23f63066.png";